// MASTER ADMIN V2 §6 — navegación agrupada por secciones de NEGOCIO.
// Reutiliza las rutas existentes: no se duplica ni se elimina ninguna página.
import {
  LayoutDashboard, Users, CreditCard, BadgeDollarSign, QrCode, Sticker,
  Handshake, BellRing, ShieldCheck, FileText, Scale, SlidersHorizontal,
  Terminal, Globe, Tag, Wallet, ScrollText, HeartPulse, Receipt,
} from "lucide-react";

export const ADMIN_NAV = [
  {
    id: "resumen",
    label: "Resumen",
    items: [
      { to: "/admin", label: "Dashboard", icon: LayoutDashboard, testid: "admin-nav-dashboard", exact: true },
    ],
  },
  {
    id: "clientes",
    label: "Clientes",
    items: [
      { to: "/admin/users", label: "Centro de clientes", icon: Users, testid: "admin-nav-users" },
      { to: "/admin/subscriptions", label: "Membresías activas", icon: BadgeDollarSign, testid: "admin-nav-subscriptions" },
      { to: "/admin/vehicles", label: "Protecciones y QR", icon: QrCode, testid: "admin-nav-vehicles" },
    ],
  },
  {
    id: "pagos",
    label: "Pagos",
    items: [
      { to: "/admin/payments", label: "Cola de pagos", icon: CreditCard, testid: "admin-nav-payments" },
      { to: "/admin/config", label: "Métodos de cobro", icon: Wallet, testid: "admin-nav-payment-config" },
    ],
  },
  {
    id: "comercial",
    label: "Planes y precios",
    items: [
      { to: "/admin/membership-plans", label: "Planes de membresía", icon: Receipt, testid: "admin-nav-membership-plans" },
      { to: "/admin/pricing-display", label: "Precio internacional", icon: Globe, testid: "admin-nav-pricing" },
      { to: "/admin/coupons", label: "Cupones", icon: Tag, testid: "admin-nav-coupons" },
      { to: "/admin/partners", label: "Socios y comisiones", icon: Handshake, testid: "admin-nav-partners" },
    ],
  },
  {
    id: "stickers",
    label: "Diseños de stickers",
    items: [
      { to: "/admin/sticker-templates", label: "Estudio de plantillas", icon: Sticker, testid: "admin-nav-sticker-templates" },
    ],
  },
  {
    id: "comunicaciones",
    label: "Comunicaciones",
    items: [
      { to: "/admin/push-health", label: "Salud de notificaciones", icon: BellRing, testid: "admin-nav-push-health" },
      { to: "/admin/twilio", label: "Estado de Twilio", icon: HeartPulse, testid: "admin-nav-twilio" },
    ],
  },
  {
    id: "seguridad",
    label: "Seguridad y privacidad",
    items: [
      { to: "/admin/safety", label: "Centro de seguridad", icon: ShieldCheck, testid: "admin-nav-safety" },
    ],
  },
  {
    id: "contenido",
    label: "Contenido web y APP",
    items: [
      { to: "/admin/site-content", label: "Contenido del sitio", icon: FileText, testid: "admin-nav-content" },
      { to: "/admin/shared-content", label: "Contenido compartido", icon: Globe, testid: "admin-nav-shared-content" },
      { to: "/admin/legal", label: "Documentos legales", icon: Scale, testid: "admin-nav-legal" },
    ],
  },
  {
    id: "sistema",
    label: "Auditoría y herramientas",
    items: [
      { to: "/admin/logs", label: "Registro de actividad", icon: ScrollText, testid: "admin-nav-logs" },
      { to: "/admin/runtime-logs", label: "Diagnóstico técnico", icon: Terminal, testid: "admin-nav-runtime-logs" },
      { to: "/admin/users/add", label: "Alta manual de cliente", icon: SlidersHorizontal, testid: "admin-nav-add-user" },
    ],
  },
];

export const isNavItemActive = (item, pathname) => {
  if (item.exact) return pathname === item.to;
  return pathname === item.to || pathname.startsWith(`${item.to}/`);
};
